// "Other" choice for Checkbox/Radio items with `hasOther: true`. The controls
// bind OTHER_OPTION as a sentinel; the answer replaces it with the
// respondent's trimmed text, so submissions, exports, mappings, and conditions
// see plain strings. A selected Other with blank text contributes nothing.
export const OTHER_OPTION = '$$other';

// The author's wording for the Other choice (`otherLabel`), or `fallback` (the
// localized "Other") when blank.
export function otherChoiceLabel(item, fallback) {
	return (item.otherLabel || '').trim() || fallback;
}

// The author's hint for the Other text box; blank means no placeholder.
export function otherPlaceholder(item) {
	return (item.otherPlaceholder || '').trim();
}

function toList(value) {
	if (value === null || value === undefined || value === '') return [];
	return Array.isArray(value) ? value : [value];
}

// Rebuilds the control state from a saved answer (an array for Checkbox, a
// string for Radio): values outside the configured options are Other text.
export function splitOtherAnswer(item, value) {
	const values = toList(value);
	if (!item.hasOther) return { selection: values, otherText: '' };
	const options = item.options || [];
	const known = values.filter((v) => options.includes(v));
	const custom = values.filter((v) => !options.includes(v) && v !== OTHER_OPTION);
	return { selection: custom.length ? [...known, OTHER_OPTION] : known, otherText: custom.join(', ') };
}

// The answer values for a selection, with Other replaced by its text.
export function otherAnswerValues(selection, otherText) {
	const text = (otherText || '').trim();
	return toList(selection).flatMap((v) => (v === OTHER_OPTION ? (text ? [text] : []) : [v]));
}
